import config from './../modules/Config/Config';
import tracker from './tracker';
import jQuery from 'jquery';
import './gtrack';

// Make sure that there are genoo accounts set up for this environment
var gLoader = jQuery.Deferred(),
    gload = gLoader.promise(),
    loadTimer = null,
    timeout = 5000,
    start = Date.now(),
    trackerLoader = jQuery.Deferred(),
    trackerLoad = trackerLoader.promise();

export default tracker({
  name: 'Genoo',
  conf: config.genoo && config.genoo || [],
  library: function libFn() {
    loadTimer = setInterval(
      function() {
        if (window.GTrack) {
          gLoader.resolve(window.GTrack);
          clearInterval(loadTimer);
        } else if ((Date.now() - start) > timeout) {
          gLoader.reject({
            msg: 'Genoo took too long to load'
          });
          clearInterval(loadTimer);
        }
      },
      1000
    );
  },
  initialize: function initFn(trackingOptions) {
    gload.then(function(g) {
      try {
        window.gTracker = g.getTracker('https://api.genoo.com/servlet/tracking', trackingOptions.key);
        window.gTracker.setDocumentTitle(document.title);
        window.gTracker.enableLinkTracking();
        trackerLoader.resolve(window.gTracker);
      } catch (err) {}
    }).catch(function(err) {});
  },
  track: function trackFn(trackId, trackingArgs) {
    if (trackingArgs.length === 2) {
      if (trackingArgs[0] === 'send' && trackingArgs[1] === 'pageview') {

        // Ensure we are chaining promises in the call order
        trackerLoad = trackerLoad.then(function(tracker) {
          tracker.trackPageView();
          return tracker;
        });
      }
    } else if (trackingArgs.length === 3) {
      if (trackingArgs[0] === 'set' && trackingArgs[1] === 'location') {

        // Ensure we are chaining promises in the call order
        trackerLoad = trackerLoad.then(function(tracker) {
          tracker.setTrackingUrl(trackingArgs[2]);
          return tracker;
        });
      }
    }
  }
})